import '../scss/app.scss' 

import $ from 'jquery';
//import whatInput from 'what-input';

import './lib/slick.min.js';

import mediabox from 'mediabox';
mediabox('.mediabox');

window.$ = $;


import Foundation from 'foundation-sites';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line belowgulp

import './adherents.js';




$(document).ready(function(){
  console.log ('init');


  // Init
  aspectRatio();
  $(document).foundation();

  $(window).on('resize', function(){
      aspectRatio();
  });

  if ($('.m-header-slide').length>1){
    $('.m-header-container-slider').slick({
      autoplay:true,
      arrows:false,
      dots:true,
      speed: 500,

    });
  }

});



  //////////////////////////
  //
  //  FONCTIONS GÉNÉRIQUES
  //
  //////////////////////////


function aspectRatio() {

  var width  = $('.m-header-slider').outerWidth();
  if ($(window).width() <= 639) {
    var height = (width*600)/700;
  } else if ($(window).width() <= 1200) {
    var height = (width*500)/1200;
  }
  $('.m-header-slide').outerHeight(height);
  $('.m-header-slider').outerHeight(height);
}


function masque_recherche() {
    $("section").show(), $("header").show(), $(".section").show(), $("#menu-recherche .close-button").hide(), $(".conteneur-resultats").removeClass("actif"), $(".conteneur-resultats").css("marginTop", 0), $("#menu-recherche").attr("data-close-on-click", !0)
}

$(".sticky").on("sticky.zf.stuckto:top sticky.zf.unstuckfrom:top", function() {
    0 == recherche && $(".dropdown-pane").foundation("close")
}), $(".selection-guide").on("change", function() {
    $(".guide-groupe").hide(), $('.guide-groupe[data-guide-annee="' + this.value + '"]').show()
}), $("form#recherche button").on("click", function(e) {
    e.preventDefault
}), $(".bt-print").on("click", function(e) {
    window.print()
}), $(function() {
    $(document).foundation(), $("#menu-recherche .close-button").on("click", function(e) {
        $("#menu-recherche").foundation("close"), masque_recherche()
    }), jQuery("form").on("keyup", "#s", function() {
        this.value.length > 0 && (!1 === recherche && ($("section").hide(), $("header").hide(), $(".section").hide(), $("#menu-recherche .close-button").show(), $(".conteneur-resultats").addClass("actif"), $("#menu-recherche").attr("data-close-on-click", !1), $(".conteneur-resultats").css("marginTop", $("#menu-recherche").height())), recherche = !0), 0 === this.value.length && (!0 === recherche && masque_recherche(), recherche = !1)
    }), $("#choix-annee").change(function() {
        var url = new URL($(location).attr("href"));

        if( Number.isInteger( Number.parseInt(this.value) ) ) url.searchParams.set('annee', this.value);
        else url.searchParams.delete('annee');
        $(location).attr("href",url);

    })
}), $("form#recherche").submit(function(e) {
    e.preventDefault()
});

$(".moins").on("click", function(e) {
  $(this).hide();
  $(this).siblings(".plus").show();
  console.log('ici');
})
$(".plus").on("click", function(e) {
      $(this).hide();
      $(this).siblings(".moins").show();
      console.log('là');
})




var initClasses = ["mui-enter", "mui-leave"],
    activeClasses = ["mui-enter-active", "mui-leave-active"],
    endEvent = function() {
        var e = {
                transition: "transitionend",
                WebkitTransition: "webkitTransitionEnd",
                MozTransition: "transitionend",
                OTransition: "otransitionend"
            },
            t = window.document.createElement("div");
        for (var n in e)
            if (void 0 !== t.style[n]) return e[n];
        return null
    }(),
    MotionUI = {
        animateIn: function(e, t, n) {
            animate(!0, e, t, n)
        },
        animateOut: function(e, t, n) {
            animate(!1, e, t, n)
        }
    },
    recherche = !1;





